import { ComponentType, FC } from 'react';
import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { FeatureSubscriptionContext, useFeatureSubscriptionConfig } from '@frontend/self-upgrade';
import { FreemiumUpgradeAlert } from './freemium-upgrade-alert';
import FormsFreemiumMain from './main';

interface DigitalFormsFreemiumMainProps {
  children: React.ReactNode;
  isSettingsPage?: boolean;
  showBanner?: boolean;
}
//incase we need to have a store for the Freemium feature in future, we can add it's provider here. For now, it just wraps the main component.
export const DigitalFormsFreemiumWrapper: FC<DigitalFormsFreemiumMainProps> = ({ children, showBanner = false }) => {
  const config = useFeatureSubscriptionConfig({
    feature: Feature.FORMS,
  });

  return (
    <FeatureSubscriptionContext.Provider value={config}>
      <FormsFreemiumMain>
        {showBanner && <FreemiumUpgradeAlert feature={Feature.FORMS} />}
        {children}
      </FormsFreemiumMain>
    </FeatureSubscriptionContext.Provider>
  );
};

export const withFormsFreemium = <P extends object>(Component: ComponentType<P>): FC<P> => {
  const WrappedComponent: FC<P> = (props) => {
    return (
      <DigitalFormsFreemiumWrapper>
        <Component {...props} />
      </DigitalFormsFreemiumWrapper>
    );
  };

  WrappedComponent.displayName = `withFormsFreemium(${Component.displayName || Component.name || 'Component'})`;

  return WrappedComponent;
};
